<div class="user-information">
  <strong class="username" [title]="userInfo.username" data-testid="header-username">{{ userInfo.username }}</strong>

  <div class="actions">
    <a href="#" (click)="logout()" data-testid="header-logout">
      {{ "HEADER.LOGOUT" | translate }}
    </a>
  </div>
</div>
